import RecruitHeaderSectionImage1 from '../../assets/recruit_header_section_image1.png';
import { FrameLayout, useResponsivePadding, VerticalLayout } from '../../common/common-layout';
import { SubH1 } from '../../common/common-text';
import { pxToRem } from '../../common/utils/ConvertUtils';
import '../../css/bbpage.css';
import { useDeviceType } from '../../hooks/useDeviceType';


const RecruitHeaderSection = () => {
  const { horizontal: padding } = useResponsivePadding(/*{ mode: 'fixed' }*/);
  const { isMobile } = useDeviceType();

  return (
    <VerticalLayout style={{
      background: '#1c3c6b',
      width: '100%',
      ...(!isMobile ? { aspectRatio: '1920 / 600' } : {}),
    }}>
      <FrameLayout>
        <img src={RecruitHeaderSectionImage1} style={{
          width: '100%',
          height: isMobile ? '300px' : '100%',
          objectFit: isMobile ? 'cover' : 'unset',
          objectPosition: 'center',
          display: 'block',
        }} />
        <SubH1
          style={{
            color: 'white',
            position: 'absolute',
            bottom: isMobile ? 26 : `${pxToRem(70)}`,
            left: `${padding}px`,
          }}
        >
          Recruit
        </SubH1>
      </FrameLayout>
    </VerticalLayout>
  );
};

export default RecruitHeaderSection;
